module.exports = __webpack_public_path__ + "img/ThePulseDogecoinStakingCarnivalTicketLogo.90dc9820.png";